// extracted by mini-css-extract-plugin
module.exports = {"default":"input_phone-module__default___xdS4H"};